import { render, staticRenderFns } from "./OnlineBiddingResultList.vue?vue&type=template&id=34742a76&scoped=true&"
import script from "./OnlineBiddingResultList.vue?vue&type=script&lang=js&"
export * from "./OnlineBiddingResultList.vue?vue&type=script&lang=js&"
import style0 from "./OnlineBiddingResultList.vue?vue&type=style&index=0&id=34742a76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34742a76",
  null
  
)

export default component.exports